'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function orientStyles(styles, rtl) {
    styles = styles || {};

    var keyMapping = {
        paddingInlineStart: rtl ? 'paddingRight' : 'paddingLeft',
        paddingInlineEnd: rtl ? 'paddingLeft' : 'paddingRight',
        marginInlineStart: rtl ? 'marginRight' : 'marginLeft',
        marginInlineEnd: rtl ? 'marginLeft' : 'marginRight',
        inlineStart: rtl ? 'right' : 'left',
        inlineEnd: rtl ? 'left' : 'right'
    };

    var valMapping = {
        inlineStart: rtl ? 'right' : 'left',
        inlineEnd: rtl ? 'left' : 'right'
    };

    var _helper = function _helper(obj) {
        var ret = {};

        _lodash2.default.each(_lodash2.default.keys(obj), function (key) {
            if ((0, _typeof3.default)(obj[key]) == 'object') {
                ret[key] = orientStyles(obj[key], rtl);
            } else if (typeof obj[key] == 'function') {
                // Do nothing
            } else if (keyMapping[key]) {
                ret[keyMapping[key]] = obj[key];
            } else {
                ret[key] = obj[key];
            }
        });

        if (ret.textAlign && valMapping[ret.textAlign]) {
            ret.textAlign = valMapping[ret.textAlign];
        }

        return ret;
    };

    return _helper(styles);
}

exports.default = orientStyles;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wix-restaurants-renderer-js/dist/utils/directionalstyles.js
// module id = 178
// module chunks = 0